const OPENING_HOURS_DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
var OpenClosedStatus = /* @__PURE__ */ ((OpenClosedStatus2) => {
  OpenClosedStatus2["Open"] = "OPEN";
  OpenClosedStatus2["Closing"] = "CLOSING";
  OpenClosedStatus2["Closed"] = "CLOSED";
  return OpenClosedStatus2;
})(OpenClosedStatus || {});
const ACCESSIBILITY_WHEELCHAIR = "Wheelchair";
const FRANCHISE_STORE = "Franchise store";
export {
  ACCESSIBILITY_WHEELCHAIR,
  FRANCHISE_STORE,
  OPENING_HOURS_DAYS,
  OpenClosedStatus
};
//# sourceMappingURL=types.js.map
